import { createFileRoute } from "@tanstack/react-router";
import TmsCoconutCreek from "@/pages/local/TmsCoconutCreek";
export const Route = createFileRoute("/tms-coconut-creek")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Coconut Creek | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy for patients near Coconut Creek, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:title",
          content: "TMS Coconut Creek | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy for patients near Coconut Creek, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-coconut-creek",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-coconut-creek",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsCoconutCreek />;
}
